import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=4cce2615&scoped=true&"
import script from "./Emails.vue?vue&type=script&lang=js&"
export * from "./Emails.vue?vue&type=script&lang=js&"
import style0 from "./Emails.vue?vue&type=style&index=0&id=4cce2615&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cce2615",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cce2615')) {
      api.createRecord('4cce2615', component.options)
    } else {
      api.reload('4cce2615', component.options)
    }
    module.hot.accept("./Emails.vue?vue&type=template&id=4cce2615&scoped=true&", function () {
      api.rerender('4cce2615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/Emails.vue"
export default component.exports